import React from 'react';
import Chip from '@mui/material/Chip';
import LocationOnIcon from '@mui/icons-material/LocationOn';

interface PlaceProps {
  place: string;
  removePlace: () => void;
}

const Place = ({ place, removePlace }: PlaceProps) => {
  return (
    place && (
      <Chip
        size="small"
        icon={<LocationOnIcon />}
        label={place}
        onDelete={() => removePlace()}
      />
    )
  );
};

export default Place;
